import { getCurrentProduct } from '@components/orders-sales/helper';
import { Popin, State } from '@components/orders-sales/type';
import { ToastType } from '@hooks/orders-sales/use-toast';
import { Product } from '@interfaces/models/orderSaleProduct';
import { createContext, PropsWithChildren, useEffect, useState } from 'react';

export interface TimelineContextProps {
  state?: State;
  selectedProduct?: Product;
  updateState: (s: State) => void;
  updatePopin: (p: Popin | null) => void;
  // For Toast
  toast?: ToastType;
  removeToast: () => void;
  showToast: (data: ToastType) => void;
}

// Create the context with default values
const TimelineContext = createContext<TimelineContextProps>({
  state: undefined,
  selectedProduct: undefined,
  updateState: () => {},
  updatePopin: () => {},
  // For Toast
  toast: undefined,
  removeToast: () => {},
  showToast: () => {},
});

interface TimelineProviderProps extends TimelineContextProps, PropsWithChildren {
  children: React.ReactNode;
}

const TimelineProvider = ({
  children,
  state,
  updateState,
  updatePopin,
  toast,
  showToast,
  removeToast,
}: TimelineProviderProps) => {
  const [selectedProduct, setSelectedProduct] = useState<Product>();

  useEffect(() => {
    if (state) {
      const product = getCurrentProduct(state);
      setSelectedProduct(product);
    }
  }, [state]);

  return (
    <TimelineContext
      value={{
        state,
        selectedProduct,
        updateState,
        updatePopin,
        // For toast
        toast,
        showToast,
        removeToast,
      }}
    >
      {children}
    </TimelineContext>
  );
};

export { TimelineContext, TimelineProvider };
